/**
 * Hook to open the third-party connector setup modal.
 * Currently a stub that logs to console.
 *
 * @returns Object with openSetupModal callback
 */
export function useSetupConnector() {
	const openSetupModal = (connectorKey: string) => {
		// TODO(TWCG-1489): Lazy-import ThirdPartyConnectorConfiguration from
		// @atlassian/third-party-connector-configuration and call openModal(connectorKey).
		// This will handle the full connector auth flow.
		// eslint-disable-next-line no-console
		console.log('[TWCG-1489] Setup connector:', connectorKey);
	};

	return { openSetupModal };
}
